var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-roboto"},[_c('div',{staticClass:"wrapper"},[_c('Breadcrumb',{attrs:{"title":this.$t('lbl_EMPBE_Blacklist')}}),_c('div',{staticClass:"mb-0 f-24 d-flex justify-content-between align-items-center gap-3 w-100"},[_c('div',{staticClass:"h6"},[_vm._v(" "+_vm._s(_vm.pageDesc)+" ")])]),_c('Grid')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }